export const changeContractTypeReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_CONTRACT_TYPE":
        return action.payload.contractType;
      default:
        return state;
    }
  };
  